module.exports = __webpack_public_path__ + "fonts/HelveticaNowDisplay-XBold.ad5f6a6e5a63d89374c3d68637dd604b.woff";